import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from '../../api/axiosConfig';
import PrintableOrder from '../printable/PrintableOrder'; // Correct path
import LoadingSpinner from '../../components/common/LoadingSpinner';

// Define the expected structure of the fetched order data
// (Should match the structure returned by getOrderById)
interface OrderDataPrint {
  id: number;
  orderNumber: string;
  orderDate: Date | string; // Assuming createdAt or a specific orderDate field
  createdAt: Date | string; // Add createdAt for fallback
  Client: { // Correct casing
    name: string;
    director?: string | null;
    phone?: string | null;
    email?: string | null;
    address?: string | null;
  };
  status: string;
  totalAmount: number;
  discount: number;
  finalAmount: number;
  paidAmount: number;
  paymentTerms?: string | null;
  notes?: string | null;
  OrderItems: Array<{
    id: number;
    Structure: { // Expect uppercase 'Structure'
      code: string;
      type: string;
      location: string;
    };
    startDate: Date | string;
    endDate: Date | string;
    price: number;
    discount?: number | null;
    total: number;
  }>;
}

const OrderPrintPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [orderData, setOrderData] = useState<OrderDataPrint | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchOrderData = async () => {
      setLoading(true);
      setError(null);
      try {
        // Use the new backend endpoint for order print data
        const response = await axios.get<OrderDataPrint>(`/orders/${id}/print-data`);
        // Assuming the backend returns the necessary 'orderDate' field or we use 'createdAt'
        const fetchedData = {
          ...response.data,
          orderDate: response.data.orderDate || response.data.createdAt // Fallback if orderDate is not specific
        };
        setOrderData(fetchedData);
        // Attempt to trigger print dialog after data is loaded
        setTimeout(() => {
          // window.print();
        }, 500); // Small delay
      } catch (err: any) {
        console.error('Error fetching order data for printing:', err);
        setError(err.response?.data?.message || 'Не удалось загрузить данные заказа для печати.');
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchOrderData();
    } else {
      setError('ID заказа не найден.');
      setLoading(false);
    }
  }, [id]);

  if (loading) {
    return <LoadingSpinner />;
  }

  if (error) {
    return <div className="printable-container error-message">Ошибка: {error}</div>;
  }

  if (!orderData) {
    return <div className="printable-container">Данные для печати не найдены.</div>;
  }

  // Render the printable component with the fetched data
  return <PrintableOrder orderData={orderData} />;
};

export default OrderPrintPage;
